import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const QuemSouEuPage = lazy(() => import('../pages/quem-sou-eu/page'));
const PatrocinadoresPage = lazy(() => import('../pages/patrocinadores/page'));
const PromocoesPage = lazy(() => import('../pages/promocoes/page'));
const AreaAssinantesPage = lazy(() => import('../pages/area-assinantes/page'));
const LoginPage = lazy(() => import('../pages/login/page'));
const CadastroPage = lazy(() => import('../pages/cadastro/page'));
const PerfilPage = lazy(() => import('../pages/perfil/page'));
const NoticiasPage = lazy(() => import('../pages/noticias/page'));
const NoticiaDetalhePage = lazy(() => import('../pages/noticias/[slug]/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));
const AdminUsuariosPage = lazy(() => import('../pages/admin/usuarios/page'));
const AdminPaisesPage = lazy(() => import('../pages/admin/paises/page'));
const AdminPromocoesPage = lazy(() => import('../pages/admin/promocoes/page'));
const AdminNoticiasPage = lazy(() => import('../pages/admin/noticias/page'));
const AdminPatrocinadoresPage = lazy(() => import('../pages/admin/patrocinadores/page'));
const AdminAreaVIPPage = lazy(() => import('../pages/admin/area-vip/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/quem-sou-eu',
    element: <QuemSouEuPage />,
  },
  {
    path: '/patrocinadores',
    element: <PatrocinadoresPage />,
  },
  {
    path: '/promocoes',
    element: <PromocoesPage />,
  },
  {
    path: '/area-assinantes',
    element: <AreaAssinantesPage />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/cadastro',
    element: <CadastroPage />,
  },
  {
    path: '/perfil',
    element: <PerfilPage />,
  },
  {
    path: '/noticias',
    element: <NoticiasPage />,
  },
  {
    path: '/noticias/:slug',
    element: <NoticiaDetalhePage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/usuarios',
    element: <AdminUsuariosPage />,
  },
  {
    path: '/admin/paises',
    element: <AdminPaisesPage />,
  },
  {
    path: '/admin/promocoes',
    element: <AdminPromocoesPage />,
  },
  {
    path: '/admin/noticias',
    element: <AdminNoticiasPage />,
  },
  {
    path: '/admin/patrocinadores',
    element: <AdminPatrocinadoresPage />,
  },
  {
    path: '/admin/area-vip',
    element: <AdminAreaVIPPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
